import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {InventoryBarcodeReportData} from "./inventory-barcode-report.data";

@Injectable()
export class InventoryBarcodeReportModel extends ReportModel<InventoryBarcodeReportData> {
    constructor(injector: Injector) {
        super(injector, InventoryBarcodeReportData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
